/**
 * Etichette delle scelte del form immobile.
 *
 * Stanno qui e non nei singoli step perche' le rilegge anche la notifica email:
 * il template gira server-side e riceve chiavi, non etichette. Senza una fonte
 * unica, all'agenzia arriva una mail che dice "da_ristrutturare".
 */
export interface Opzione {
  value: string
  label: string
}

export const PROPERTY_TYPE_OPTIONS: Opzione[] = [
  { value: 'appartamento', label: 'Appartamento' },
  { value: 'villa', label: 'Villa' },
  { value: 'villetta', label: 'Villetta a schiera' },
  { value: 'attico', label: 'Attico' },
  { value: 'loft', label: 'Loft' },
  { value: 'monolocale', label: 'Monolocale' },
]

export const FLOOR_OPTIONS: Opzione[] = [
  { value: 'interrato', label: 'Piano interrato' },
  { value: 'terra', label: 'Piano terra' },
  { value: 'primo', label: 'Primo piano' },
  { value: 'secondo', label: 'Secondo piano' },
  { value: 'terzo', label: 'Terzo piano' },
  { value: 'quarto', label: 'Quarto piano' },
  { value: 'quinto_o_superiore', label: 'Quinto piano o superiore' },
]

export const CONDITION_OPTIONS: Opzione[] = [
  { value: 'nuovo', label: 'Nuovo / Mai abitato' },
  { value: 'ristrutturato', label: 'Ristrutturato di recente' },
  { value: 'buono', label: 'Buono stato' },
  { value: 'da_ristrutturare', label: 'Da ristrutturare' },
]

/** Etichetta corrispondente al valore, o il valore stesso se non e' in elenco. */
export function labelOpzione(options: Opzione[], value?: string | null): string {
  if (!value) return ''
  return options.find((o) => o.value === value)?.label || value
}
